export default __webpack_public_path__ + "b2a8fa3d8baba9fc720f8a71e3abdda2.gif";